import { Navigate, Route, Routes } from 'react-router-dom';
import { ManageAccessApp } from './pages/access/manage-access-app';
import { LoginApp } from './pages/account/login/login-app';
import { Logout } from './pages/account/logout';
import { RegisterApp } from './pages/account/register/register-app';
import { UserProfileApp } from './pages/account/user-profile/user-profile-app';
import { AccessRoleApp } from './pages/admin/access-role-page/access-role-app';
import { AccessTeamApp } from './pages/admin/access-team-page/access-team-app';
import { AccessTeamRoleApp } from './pages/admin/access-team-role-page/access-team-role-app';
import { AccessTeamUserApp } from './pages/admin/access-team-user-page/access-team-user-app';
import { CategoryApp } from './pages/admin/category-page/category-app';
import { ContactUsApp } from './pages/admin/contact-us-page/contact-us-app';
import { CountryApp } from './pages/admin/country-page/country-app';
import { LicenseApp } from './pages/admin/license-page/license-app';
import { PageApp } from './pages/admin/page-page/page-app';
import { ProductApp } from './pages/admin/product-page/product-app';
import { RedeemCodeApp } from './pages/admin/redeem-code-page/redeem-code-app';
import { RegionApp } from './pages/admin/region-page/region-app';
import { RepresentativeApp } from './pages/admin/representative-page/representative-app';
import { SmsLogApp } from './pages/admin/sms-log-page/sms-log-app';
import { SmsStatusApp } from './pages/admin/sms-status-page/sms-status-app';
import { SmsTypeApp } from './pages/admin/sms-type-page/sms-type-app';
import { SysLogApp } from './pages/admin/sys-log-page/sys-log-app';
import SysMenuGroupsApp from './pages/admin/sys-menus/sys-menu-groups';
import { SystemSettingApp } from './pages/admin/system-setting-page/system-setting-app';
import { UserAgentApp } from './pages/admin/user-agent-page/user-agent-app';
import { UserLogApp } from './pages/admin/user-log-page/user-log-app';
import { UserSessionApp } from './pages/admin/user-session-page/user-session-app';
import { HomeApp } from './pages/home/dashboard/home-app';
import { NotFound } from './pages/shared/not-found';
import { Protected } from './pages/shared/protected';
import { PublicLayout } from './pages/shared/public-layout';
import { LicenseCodeApp } from './pages/admin/license-code-page/license-code-app';
import TicketApp from './pages/admin/ticket-page/ticket-app';
import TutorialApp from './pages/admin/tutorial-page/tutorial-app';
import UserLicenseApp from './pages/admin/user-license-page/user-license-app';
import { UserProfileApp as AdminUserProfileApp } from './pages/admin/user-profile-page/user-profile-app';
import { LicenseActivationReportApp } from './pages/admin/license-activation-report-page/license-activation-report-app';

export const AppRoutes = () => {
    return (
        <Routes>
            <Route element={<PublicLayout />}>
                <Route element={<Protected />}>
                    <Route path="/home" element={<HomeApp />} />
                    {/* admin */}
                    <Route path="/admin/tickets" element={<TicketApp />} />
                    <Route path="/admin/tutorials" element={<TutorialApp />} />
                    <Route path="/admin/user-licenses" element={<UserLicenseApp />} />
                    <Route
                        path="/admin/manage-users"
                        element={<ManageAccessApp selectedTab="users" />}
                    />
                    <Route path="/admin/sms-status" element={<SmsStatusApp />} />
                    <Route path="/admin/sms-type" element={<SmsTypeApp />} />
                    <Route path="/admin/user-log" element={<UserLogApp />} />
                    <Route path="/admin/user-session" element={<UserSessionApp />} />
                    <Route path="/admin/access-role" element={<AccessRoleApp />} />
                    <Route path="/admin/access-team-role" element={<AccessTeamRoleApp />} />
                    <Route path="/admin/redeem-code" element={<RedeemCodeApp />} />
                    <Route path="/admin/sys-log" element={<SysLogApp />} />
                    <Route path="/admin/sys-menu-group" element={<SysMenuGroupsApp />} />
                    <Route path="/admin/access-team" element={<AccessTeamApp />} />
                    <Route path="/admin/user-agent" element={<UserAgentApp />} />
                    <Route path="/admin/access-team-user" element={<AccessTeamUserApp />} />
                    <Route path="/admin/sms-reports" element={<SmsLogApp />} />
                    <Route path="/admin/product" element={<ProductApp />} />
                    <Route path="/admin/system-setting" element={<SystemSettingApp />} />
                    <Route path="/admin/license" element={<LicenseApp />} />
                    <Route path="/admin/license-code" element={<LicenseCodeApp />} />
                    <Route path="/admin/representative" element={<RepresentativeApp />} />
                    <Route path="/admin/country" element={<CountryApp />} />
                    <Route path="/admin/region" element={<RegionApp />} />
                    <Route path="/admin/contact-us" element={<ContactUsApp />} />
                    <Route path="/admin/category" element={<CategoryApp />} />
                    <Route path="/admin/page" element={<PageApp />} />
                    <Route path="/admin/user-profile" element={<AdminUserProfileApp />} />
                    <Route path="/admin/license-activation-report" element={<LicenseActivationReportApp />} />
                    <Route path="/profile" element={<UserProfileApp />} />
                    {/* admin */}
                </Route>
            </Route>
            <Route path="/" element={<PublicLayout />}>
                <Route path="/" element={<Navigate to="/home" />} />
                <Route path="/login" element={<LoginApp />} />
                <Route path="/register" element={<RegisterApp />} />
                <Route path="/logout" element={<Logout />} />
                <Route path="*" element={<NotFound />} />
            </Route>
        </Routes>
    );
};
